import './styles.scss';
import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {BrowserRoutes} from "../../routes/BrowserRouter";
import UsersSettings from "../../components/specific/Users.settings/Users.settings";
import UserReportsContainer from "../Reports.User/Reports.User.container";

function UsersContainer() {

    return (
        <div className='users-container'>
            <div className='users-container-content'>
                <div className='users-container-content-table'>
                    <Switch>
                        <Route path={BrowserRoutes.usersParam} render={({match}) =>
                            <UsersSettings userId={match.params.userId}/>}/>
                        <Route exact path={BrowserRoutes.users} render={() =>
                            <UserReportsContainer/>}/>
                    </Switch>
                </div>
            </div>
        </div>
    )
}

export default UsersContainer;